import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const { REACT_APP_API_URL, REACT_APP_LOCATIONIQ_TOKEN } = process.env;

export const mapSlice = createSlice({
  name: "map",
  initialState: {
    isTrackingDone: false,
    initCoords: {},
    browserCoords: {},
    country: "",
    phone: "",
    loadStatus: false,
  },
  reducers: {
    setTrackingStatus: (state, action) => {
      state.isTrackingDone = action.payload;
    },
    setBrowserCoords: (state, action) => {
      state.browserCoords = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setInitCoords: (state, action) => {
      state.initCoords = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setLoadStatus: (state, action) => {
      state.loadStatus = action.payload;
    },
  },
});

export const getGeoCode = async (value) => {
  const url = `https://eu1.locationiq.com/v1/search.php?key=${REACT_APP_LOCATIONIQ_TOKEN}&q=${value}&format=json`;
  const data = await axios.get(url);

  const { lat, lon } = data.data[0];

  return {
    lat,
    lon,
  };
};

export const getLocationByIP = async () => {
  const url = REACT_APP_API_URL + "/cf-country";
  const data = await axios.get(url);

  return data.data.country_code;
};

export const getCurrentPosition = (dispatch, action) =>
  navigator.geolocation.getCurrentPosition((position) => {
    dispatch(
      action({
        browserLat: position.coords.latitude,
        browserLng: position.coords.longitude,
      })
    );
  });

export const calculateOffset = (lat, lng) => {
  const r_earth = 6371000.0;
  const dy = 3000;
  const dx = 3000;

  const newLat = lat + (dy / r_earth) * (180 / Math.PI);
  const newLng = lng + (dx / r_earth) * (180 / Math.PI);

  return {
    newLat,
    newLng,
  };
};

export const {
  setTrackingStatus,
  setBrowserCoords,
  setPhone,
  setInitCoords,
  setCountry,
  setLoadStatus,
} = mapSlice.actions;

export const selectTrackingStatus = (state) => state.map.isTrackingDone;
export const selectBrowserCoords = (state) => state.map.browserCoords;
export const selectPhone = (state) => state.map.phone;
export const selectInitCoords = (state) => state.map.initCoords;
export const selectCountry = (state) => state.map.country;
export const selectLoadStatus = (state) => state.map.loadStatus;

export default mapSlice.reducer;
